import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import AppLayout from "../components/AppLayout";
import StyledButton from "../components/StyledButton";
import { useTranslation } from "react-i18next";
import { useSoulBackend } from "backend";
import { useUrlParams } from "hooks/useUrlParams";
import { useTheme } from "@emotion/react";

function ConfirmPayPay() {
  const { soulId } = useUrlParams();
  const location = useLocation();
  const theme = useTheme();
  const { t } = useTranslation(["common"]);
  const backend = useSoulBackend();

  // 購入画面で選んだチケット。App は episode_id、System は画面に出した価格で照合する
  const queryParams = new URLSearchParams(location.search);
  const ticket = {
    ticket_key: queryParams.get("ticket_key"),
    episode_id: queryParams.get("episode_id"),
    price: Number(queryParams.get("price")),
  };

  const [isDisabled, setIsDisabled] = React.useState(false);

  const handleRedirect = async () => {
    setIsDisabled(true);
    try {
      const { url } = await backend.purchaseWithPaypay(soulId, ticket);
      window.location.href = url;
    } catch (error) {
      console.error("Error creating PayPay QR code:", error);
      setIsDisabled(false);
    }
  };

  return (
    <AppLayout page="PayPayTicketConfirm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          {/* <Typography variant="h4" sx={{ fontSize: "15px", whiteSpace: "pre-line", fontWeight: "bold", textAlign: "center", color: COLORS.TEXT_BLACK, mt:1}}>
                {"PayPay購入時の注意"}
              </Typography> */}

          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: "16px",
                whiteSpace: "pre-line",
                fontWeight: "bold",
                textAlign: "center",
                color: "#EB8010", // 落ち着いたオレンジ文字
                backgroundColor: "#FFF9EE", // 薄オレンジ背景
                border: "1px solid #FFD591", // 枠線もやさしめ
                borderRadius: "6px",
                padding: "10px 14px",
                lineHeight: "1.6",
                mt: 1,
              })}
            >
              {t("common:PayPay.keep_app_open")}
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={(theme) => ({
              width: "50%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            })}
            onClick={handleRedirect}
            disabled={isDisabled}
          >
            {t("common:button.buy")}
          </StyledButton>
        </Box>
      </Box>
    </AppLayout>
  );
}

export default ConfirmPayPay;
